var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOpsAutomationService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5aca48;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web_Application_Support_Maintenance",
    "data-name": "Web Application Support & Maintenance"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,10A10,10,0,0,1,10,0H40A10,10,0,0,1,50,10V40A10,10,0,0,1,40,50H10A10,10,0,0,1,0,40Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "intelligent-cloud-server-network-human"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 32.57,
    cy: 13.84,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 36.09,
    cy: 17.95,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16.11,
    cy: 17.95,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.64,
    cy: 13.84,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 31.98,
    cy: 32.64,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 34.33,
    cy: 28.53,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 37.85,
    cy: 23.24,
    r: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.39,41.46V40.13A7.62,7.62,0,0,1,34.49,34,14.11,14.11,0,1,0,12,22.65a.57.57,0,0,1,0,.13L9.79,33.23h2.8a.59.59,0,0,1,.59.59v3.52h4.7a.59.59,0,0,1,.58.59v3.53ZM17.88,30.29a1.76,1.76,0,1,1,1.65-2.35h.7a.58.58,0,0,0,.58-.59v-.58h-.58a3.55,3.55,0,0,1-3.48-2.94H16a1.76,1.76,0,1,1,0-1.18h.74a3.55,3.55,0,0,1,2.3-2.73v-.79a.58.58,0,0,0-.59-.59h-.69a1.76,1.76,0,1,1-1.07-2.25,1.77,1.77,0,0,1,1.07,1.07h.69a1.79,1.79,0,0,1,1.77,1.77v.59a3.14,3.14,0,0,1,.61.05,5.26,5.26,0,0,1,1.74-3.4V15a.59.59,0,0,0-.59-.58H21.3a1.76,1.76,0,1,1,0-1.18H22A1.76,1.76,0,0,1,23.75,15v.56a5.18,5.18,0,0,1,1.76-.52v-1.9a1.77,1.77,0,0,1,1.18-3.33,1.77,1.77,0,0,1,0,3.33v1.9a5.18,5.18,0,0,1,1.76.52V15a1.77,1.77,0,0,1,1.77-1.76h.69A1.76,1.76,0,1,1,32,15.5a1.77,1.77,0,0,1-1.07-1.07h-.69a.58.58,0,0,0-.59.58v1.36a5.25,5.25,0,0,1,1.73,3.4,3.24,3.24,0,0,1,.62-.05v-.59a1.78,1.78,0,0,1,1.76-1.77h.69a1.77,1.77,0,0,1,3.33,1.18,1.77,1.77,0,0,1-3.33,0h-.69a.59.59,0,0,0-.59.59v.79a3.53,3.53,0,0,1,2.3,2.73h.75a1.76,1.76,0,1,1,1.07,2.25,1.72,1.72,0,0,1-1.07-1.07h-.75A3.54,3.54,0,0,1,32,26.77h-.59v.58a.58.58,0,0,0,.59.59h.69a1.76,1.76,0,1,1,0,1.18H32a1.77,1.77,0,0,1-1.76-1.77v-.58H29v4.7a.58.58,0,0,0,.59.58h.69A1.77,1.77,0,1,1,31.4,34.3a1.74,1.74,0,0,1-1.08-1.07h-.69a1.76,1.76,0,0,1-1.76-1.76v-4.7H26.69v6a1.76,1.76,0,1,1-2.25,1.07,1.77,1.77,0,0,1,1.07-1.07v-6H24.34v4.7a1.76,1.76,0,0,1-1.76,1.76h-.7a1.76,1.76,0,1,1,0-1.18h.7a.58.58,0,0,0,.58-.58v-4.7H22v.58a1.77,1.77,0,0,1-1.76,1.77h-.7A1.76,1.76,0,0,1,17.88,30.29Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 17.88,
    cy: 28.53,
    r: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.33,23.24A2.35,2.35,0,0,0,32,20.89a2.38,2.38,0,0,0-.95.2.58.58,0,0,1-.57-.06.6.6,0,0,1-.25-.52,1.48,1.48,0,0,0,0-.21,4.12,4.12,0,0,0-8.23,0,1.48,1.48,0,0,0,0,.21.63.63,0,0,1-.25.52.6.6,0,0,1-.58.06,2.35,2.35,0,1,0-.94,4.5H32A2.35,2.35,0,0,0,34.33,23.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 14.35,
    cy: 23.24,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 20.23,
    cy: 32.64,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 26.1,
    cy: 11.49,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 26.1,
    cy: 34.41,
    r: 0.59
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsAutomationService);
export default __webpack_public_path__ + "static/media/DevOps-Automation-Service.c6cd75c068b10e2bb91a398e8f89069e.svg";
export { ForwardRef as ReactComponent };